import Swiper from "swiper/swiper-bundle";

export function HomeTiles() {
    /* eslint-disable no-unused-vars */
    var swiper = new Swiper(".home-tiles-slider", {
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: {
            delay: 3000
        },
        loop: true,
        breakpoints: {
            1199: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            768: {
                slidesPerView: 2,
                spaceBetween: 30,
                loop: false,
                autoplay: {
                    delay: 300000
                },
            },
            640: {
                slidesPerView: 1,
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev'
        }
    });
    /* eslint-enable no-unused-vars */
}
